import { TSubMenuDropDownItemProps } from "../../../Types";
import { Link } from "react-router-dom";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";

const SubMenuDropDownItem = withLiteObserverAndTheme<TSubMenuDropDownItemProps>(
  (props) => {
    const { option, theme, isSelected, visible } = props;
    const { colors, unitY } = theme;

    return !visible ? null : (
      <Link
        to={option.link}
        id="menu-item"
        style={{
          textDecoration: "none",
          boxShadow: "none",
          backgroundColor: colors.all.transparent,
          border: "0px",
          height: 50 * unitY
        }}
        aria-disabled={false}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={16}
          text={option.title}
          isSpan={false}
          color={isSelected ? colors.all.bondiBlue : colors.all.white}
          style={{ textAlign: "left" }}
        />
      </Link>
    );
  }
);

export default SubMenuDropDownItem;
